// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ProductAutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";

export const getProductSelector = (state: ApplicationState) => state.store.components.scratchAndDentForm;

export const getProductBadges = (product: ProductAutocompleteItemModel) => {
    return "properties" in product && "badges" in product.properties && product.properties.badges.length > 0
        ? JSON.parse(product.properties.badges)
        : "";
};
